import type { Row, TableBodyPropGetter, TableBodyProps as RTTableBodyProps } from "react-table";

import { NoTableData } from "./NoTableData";

export type TableBodyProps<T extends object = {}> = {
    getTableBodyProps: (propGetter?: TableBodyPropGetter<T> | undefined) => RTTableBodyProps;
    rows: Row<T>[];
    prepareRow: (row: Row<T>) => void;
    isLoading: boolean;
    noDataMessage: string;
};

export const TableBody = <T extends object>({ getTableBodyProps, rows, prepareRow, isLoading, noDataMessage }: TableBodyProps<T>) => {
    if (rows.length === 0 || isLoading) {
        return <NoTableData noDataMessage={noDataMessage} isLoading={isLoading} />;
    }

    return (
        <tbody {...getTableBodyProps()}>
            {/* @ts-ignore todo: types */}
            {rows.map((row) => {
                prepareRow(row);
                return (
                    <tr {...row.getRowProps()}>
                        {/* @ts-ignore todo: types */}
                        {row.cells.map((cell) => (
                            <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                        ))}
                    </tr>
                );
            })}
        </tbody>
    );
};
